export default __webpack_public_path__ + "static/22-e5f2693587d25c455dc9d3ba235a71a3.png";